<template>
  <div class="container-fluid" v-if="bauprojekt_data">
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super">Wohnungsangaben</div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-container">
                  <label>Name</label>
                  <b-input-group class="form-input-group" prepend="Abc">
                    <b-form-input
                      class="form-control"
                      v-model="name"
                      name="name"
                      prepend="Abc"
                      v-bind:class="{ form_error: hasError('name') }"
                      @blur="processField"
                    ></b-form-input>
                    <feather type="check" v-if="!updating.name && !hasError('name')" class="checkmark"></feather>
                    <Loader size="20" name="name" v-if="updating.name !== false" />
                    <feather size="20" class="failmark" type="x" v-if="hasError('name')"></feather>
                  </b-input-group>
                  <label>Abkuerzung</label>
                  <b-input-group class="form-input-group" prepend="Abc">
                    <b-form-input
                      class="form-control"
                      type="text"
                      v-model="abkuerzung"
                      name="abkuerzung"
                      v-bind:class="{ form_error: hasError('abkuerzung') }"
                      @blur="processField"
                    ></b-form-input>
                    <feather type="check" v-if="!updating.abkkuerzung" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.abkkuerzung" />
                  </b-input-group>
                  <label>Etage</label>
                  <b-input-group class="form-input-group" prepend="Abc">
                    <b-form-input
                      class="form-control"
                      type="text"
                      name="etage"
                      v-model="etage"
                      v-bind:class="{ form_error: hasError('etage') }"
                      @blur="processField"
                    ></b-form-input>
                    <feather type="check" v-if="!updating.etage" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.etage" />
                  </b-input-group>
                  <label>Wohnfläche</label>
                  <b-input-group class="form-input-group" prepend="qm">
                    <b-form-input
                      class="form-control"
                      type="text"
                      name="wohnflaeche"
                      v-model="wohnflaeche"
                      v-bind:class="{ form_error: hasError('wohnfläche') }"
                      @blur="processField"
                    ></b-form-input>
                    <feather type="check" v-if="!updating.wohnflaeche" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.wohnflaeche" />
                  </b-input-group>
                  <label>Kaufpreis</label>
                  <b-input-group class="form-input-group" prepend="€">
                    <b-form-input
                      class="form-control"
                      type="text"
                      v-model="kaufpreis_json_computed"
                      name="kaufpreis_json_computed"
                      disabled
                    ></b-form-input>
                    <div class="input-buttons-inside">
                      <feather type="check" v-if="!updating.kaufpreis_json" class="checkmark"></feather>
                      <Loader size="20" v-if="updating.kaufpreis_json" />
                    </div>
                    <div class="input-buttons-right">
                      <feather type="plus" class="icon-button pointer" @click="addSubPreis()"></feather>
                      <feather type="chevron-down" class="icon-button pointer" @click="showKaufpreisDetails()"></feather>
                    </div>
                  </b-input-group>
                  <div id="show_preis" v-if="show.kaufpreis_json_show">
                    <div v-if="kaufpreis_json.length">
                      <div v-for="(prop, index) in kaufpreis_json" :key="'prop_' + index">
                        <div class="priceCon">
                          <div>{{ prop.bezeichnung }}</div>
                          <div class="infra-blue">{{ displayCurrency(prop.preis.toFixed(2).replace(".", ",")) }}</div>
                          <div><feather type="minus" class="icon-button pointer" @click="deletePreis(index)"></feather></div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      Keine Preise eingetragen.
                    </div>
                  </div>
                  <div id="add_preis" v-if="show.kaufpreis_json_add">
                    <div class="kaufpreis_inputs">
                      <b-input-group class="flex-col">
                        <label>Bezeichnung</label>
                        <b-form-input v-model="add.kaufpreis_bezeichung" name="new_kaupfreis_bezeichnung"></b-form-input>
                      </b-input-group>
                      <b-input-group class="flex-col">
                        <label>Wert</label>
                        <b-form-input v-model="add.kaufpreis_wert" name="new_kaufpreis_wert"></b-form-input>
                      </b-input-group>
                      <b-button size="md" @click="saveNewKaufpreis">Speichern</b-button>
                    </div>
                    <div id="kaufpreis_error_msg form-error" v-if="error.kaufpreis">
                      Bitte eine Bezeichnung und einen gültigen Zahlenwert eingeben.
                    </div>
                  </div>
                  <label>Zugeordnetes Haus</label>
                  <b-input-group class="form-input-group" v-if="hauser_options">
                    <b-form-select
                      v-model="selected_haus"
                      name="selected_haus"
                      :options="hauser_options"
                      @change="processInputSelect('selected_haus')"
                    ></b-form-select>
                    <feather type="check" v-if="!updating.selected_haus" class="checkmark select"></feather>
                    <Loader size="20" v-if="updating.selected_haus" class="select" />
                  </b-input-group>
                </div>
              </div>
              <div class="col col-lg-6">
                <div class="form-container">
                  <label>Kurzbeschreibung</label>
                  <b-input-group class="form-input-group">
                    <b-form-textarea
                      rows="8"
                      class="form-input-group"
                      type="textarea"
                      v-model="kurzbeschreibung"
                      name="kurzbeschreibung"
                      @blur="processField"
                    ></b-form-textarea>
                    <feather type="check" v-if="!updating.kurzbeschreibung" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.kurzbeschreibung" />
                  </b-input-group>
                  <label>Besonderheiten</label>
                  <b-input-group class="form-input-group">
                    <b-form-textarea
                      rows="4"
                      class="form-input-group"
                      type="text"
                      v-model="besonderheiten"
                      @blur="processField"
                      name="besonderheiten"
                    ></b-form-textarea>
                    <feather type="check" v-if="!updating.besonderheiten" class="checkmark"></feather>
                    <Loader size="20" v-if="updating.besonderheiten" />
                  </b-input-group>
                  <label>Status</label>
                  <b-input-group class="form-input-group" v-if="status_options">
                    <b-form-select v-model="status" :options="status_options" name="status" @change="processInputSelect('status')"></b-form-select>
                    <feather type="check" v-if="!updating.selected_haus" class="checkmark select"></feather>
                    <Loader size="20" v-if="updating.selected_haus" class="select" />
                  </b-input-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <div class="headline_under">
                  <div class="v-super">Lageicon</div>
                </div>
                <div v-if="lageicon_dropzone_options">
                  <vue-dropzone
                    ref="lageicon_dropzone"
                    :options="lageicon_dropzone_options"
                    id="lageicon_dropzone"
                    class
                    v-on:vdropzone-file-added="processUploadState"
                    v-on:vdropzone-success="processAsset"
                  ></vue-dropzone>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <div class="headline_under">
                  <div class="v-super">Grundriss</div>
                </div>
                <div v-if="grundriss_dropzone_options">
                  <vue-dropzone
                    ref="grundriss_dropzone"
                    :options="grundriss_dropzone_options"
                    id="grundriss_dropzone"
                    class
                    v-on:vdropzone-file-added="processUploadState"
                    v-on:vdropzone-success="processAsset"
                  ></vue-dropzone>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import Loader from "@/components/loader.vue";

export default {
  name: "AdminEditWohnung",
  components: {
    vueDropzone: vue2Dropzone,
    Loader: Loader,
  },
  data() {
    return {
      name: "",
      abkuerzung: "",
      etage: "",
      kurzbeschreibung: "",
      besonderheiten: "",
      wohnflaeche: "",
      kaufpreis_json: "",
      status: null,
      uploading: false,
      grundriss: false,
      lageicon: false,
      validation_errors: [],
      validation_success: [],
      status_options: [
        { value: null, text: "Status wählen" },
        { value: "verfügbar", text: "verfügbar" },
        { value: "reserviert", text: "reserviert" },
        { value: "verkauft", text: "verkauft" },
      ],
      show: {
        kaufpreis_json_add: false,
        kaufpreis_json_show: false,
      },
      error: {
        kaufpreis: false,
      },
      hauser_options: false,
      haus: this.$route.params.haus_id,
      selected_haus: false,
      haus_bp: false,
      bauprojekt_data: false,
      wohnung_data: false,
      updating: {
        name: false,
        abkuerzung: false,
        besonderheiten: false,
        etage: false,
        kaufpreis_json: false,
        wohnflaeche: false,
        kurzbeschreibung: false,
        status: false,
        selected_haus: false,
      },
      add: {
        kaufpreis_bezeichung: "",
        kaufpreis_wert: 0,
      },
      original: {},
    };
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      api: "auth/apiSettings",
      toast: "app/toasts",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      validation: "app/validation",
    }),
    dzThumbSize() {
      return 180;
    },
    kaufpreis_json_computed() {
      if (this.kaufpreis_json == null) return 0;
      let result = 0;
      this.kaufpreis_json.forEach((price) => {
        result = parseFloat(result) + parseFloat(price.preis);
      });

      return this.displayCurrency(
        parseFloat(result)
          .toFixed(2)
          .replace(".", ",")
      );
    },
  },
  created: async function() {
    //fill initial values
    this.setBpData();
    this.setWohnungData();
    this.name = this.wohnung_data.name;
    this.abkuerzung = this.wohnung_data.abkuerzung;
    this.etage = this.wohnung_data.etage;
    this.wohnflaeche = this.wohnung_data.wohnflaeche;
    this.kaufpreis_json = this.wohnung_data.kaufpreis_json;
    this.kurzbeschreibung = this.wohnung_data.kurzbeschreibung;
    this.besonderheiten = this.wohnung_data.besonderheiten;
    this.status = this.wohnung_data.status;

    //lageicon dropzone
    this.lageicon_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " + JSON.parse(localStorage.getItem("directus-sdk-js")).token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //grundriss dropzone
    this.grundriss_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " + JSON.parse(localStorage.getItem("directus-sdk-js")).token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //get bp of haus
    this.haus_bp = this.bauprojekte.find((bp) => {
      if (bp.id == this.$route.params.bauprojekt_id) return bp;
    });

    //assign hauser to select
    if (this.haus_bp.extended !== undefined) {
      this.hauser_options = this.haus_bp.extended.hauser.map((h) => {
        if (h.id == this.haus) this.selected_haus = h.id;
        return {
          value: h.id,
          text: h.name,
        };
      });
    }

    //add existing images to lageicon dropzone
    if (this.wohnung_data.lageicon) {
      let lageicon_payload = false;
      try {
        lageicon_payload = await this.$directus.getItem("directus_files", this.wohnung_data.lageicon);
      } catch (error) {
        this.$toasted.show("Error getting Lageicon Object", this.toast.failure);
      }
      if (lageicon_payload.data) {
        const file = {
          size: lageicon_payload.data.filesize,
          name: lageicon_payload.data.title,
          type: lageicon_payload.data.type,
        };
        this.$refs.lageicon_dropzone.manuallyAddFile(file, lageicon_payload.data.data.full_url);
      }
    }

    //add existing image to grundriss dropzone
    if (this.wohnung_data.grundriss) {
      let grundriss_payload = false;
      try {
        grundriss_payload = await this.$directus.getItem("directus_files", this.wohnung_data.grundriss);
      } catch (error) {
        this.$toasted.show("Error getting Grundriss Object", this.toast.failure);
      }
      if (grundriss_payload.data) {
        let file = {
          size: grundriss_payload.data.filesize,
          name: grundriss_payload.data.title,
          type: grundriss_payload.data.type,
        };
        this.$refs.grundriss_dropzone.manuallyAddFile(file, grundriss_payload.data.data.full_url);
      }
    }

    //set original values
    this.original.name = this.wohnung_data.name;
    this.original.abkuerzung = this.wohnung_data.abkuerzung;
    this.original.besonderheiten = this.wohnung_data.besonderheiten;
    this.original.etage = this.wohnung_data.etage;
    this.original.kaufpreis_json = this.wohnung_data.kaufpreis_json;
    this.original.wohnflaeche = this.wohnung_data.wohnflaeche;
    this.original.kurzbeschreibung = this.wohnung_data.kurzbeschreibung;
    this.original.status = this.wohnung_data.status;
    this.original.selected_haus = this.wohnung_data.haus;
  },
  methods: {
    async deletePreis(idx) {
      this.kaufpreis_json.splice(idx, 1);
      const payload = {
        collection: "wohnung",
        item: this.wohnung_data.id,
        changes: {
          kaufpreis_json: this.kaufpreis_json,
        },
      };

      try {
        this.updating.kaufpreis_json = true;
        this.$store.dispatch("app/mutate", payload);
      } catch (error) {
        console.log("Error removing price");
        console.log(error);
      } finally {
        this.updating.kaufpreis_json = false;
      }
    },
    async saveNewKaufpreis() {
      this.error.kaufpreis = false;
      if (this.add.kaufpreis_bezeichung == "" || this.add.kaufpreis_wert == 0) {
        this.error.kaufpreis = true;
        return;
      } else {
        if (this.kaufpreis_json == null) this.kaufpreis_json = [];

        const newKp = {
          bezeichnung: this.add.kaufpreis_bezeichung,
          preis: parseFloat(this.add.kaufpreis_wert.replace(",", ".")),
        };

        this.kaufpreis_json.push(newKp);

        const payload = {
          collection: "wohnung",
          item: this.wohnung_data.id,
          changes: {
            kaufpreis_json: this.kaufpreis_json,
          },
        };

        try {
          this.updating.kaufpreis_json = true;
          await this.$store.dispatch("app/mutate", payload);
        } catch (e) {
          console.log("Error saving new Kaufpreis.");
          console.log(e);
        } finally {
          this.updating.kaufpreis_json = false;
          this.show.kaufpreis_json_add = false;
          this.add.kaufpreis_wert = "";
          this.add.kaufpreis_bezeichung = "";
        }
      }
    },
    showKaufpreisDetails() {
      console.log(this.kaufpreis_json);
      this.show.kaufpreis_json_show = this.show.kaufpreis_json_show ? false : true;
      this.show.kaufpreis_json_add = false;
    },
    addSubPreis() {
      this.show.kaufpreis_json_add = this.show.kaufpreis_json_add ? false : true;
      this.show.kaufpreis_json_show = false;
    },
    processUploadState() {
      return true;
    },
    async processInputSelect(select) {
      const changedValue = this.original[select] !== this[select];
      if (!changedValue) return;
      let changedData = {};
      let selectIndex = select.indexOf("selected_") > -1 ? select.split("selected_")[1] : select;
      changedData[selectIndex] = this[select];

      this.updating[select] = true;

      try {
        let response = await this.$directus.updateItem("wohnung", this.wohnung_data.id, changedData);
        console.log(response);
        await this.$store.dispatch("app/updateSingle", {
          resource: "wohnung",
          id: this.wohnung_data.id,
        });
        if (select == "haus") await this.$store.dispatch("app/apiGetHouses");
        this.updating[select] = false;
      } catch (error) {
        console.log(error);
      }
    },
    async processField(field) {
      const changedField = field.target.name;
      const changed = this.original[changedField] !== this[changedField];

      if (!changed) {
        const errorVisible = this.validation_errors.indexOf(changedField);
        if (errorVisible > -1) this.validation_errors.splice(errorVisible, 1);
        return;
      }

      //validate
      const validationResult = await this.validate(field.target.name);

      if (!validationResult) {
        this.validation_errors.push(changedField);
        return;
      }

      let changedData = {};
      changedData[changedField] = this[changedField];
      this.updating[changedField] = true;

      try {
        await this.$directus.updateItem("wohnung", this.wohnung_data.id, changedData);
        await this.$store.dispatch("app/updateSingle", {
          resource: "wohnung",
          id: this.wohnung_data.id,
        });
        this.updating[changedField] = false;
        this.original[changedField] = this[changedField];
      } catch (error) {
        this.$toasted.show("Error in processField.", this.toast.failure);
      }
    },
    async processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.error);
        return;
      }
      this.$toasted.show(data.data.filename_download + " Datum.", this.toast.success);

      //check what type of asset was uploaded
      const asset_type = response.previewElement.parentNode.id.split("_")[0];

      //tag the item in directus with the correct asset type
      this.$directus.updateItem("directus_files", data.data.id, {
        tags: [asset_type, "draft"],
      });
      this[asset_type] = data.data.id;

      let updatePayload = null;
      //set payload type
      switch (asset_type) {
        case "lageicon":
          updatePayload = {
            lageicon: data.data.id,
          };
          break;
        case "grundriss":
          updatePayload = {
            grundriss: data.data.id,
          };
          break;
      }

      try {
        await this.$directus.updateItem("wohnung", this.$route.params.wohnung_id, updatePayload);
        await this.$store.dispatch("app/apiGetWohnungen");
      } catch (error) {
        console.log(error);
      }
    },
    async validate(field) {
      const fieldName = field;
      this.validation_errors.splice(0, this.validation_errors.length);
      const errorExists = this.validation_errors.indexOf(fieldName);
      const validationExists = this.validation_success.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);
      if (validationExists > -1) this.validation_success.splice(validationExists, 1);

      const validationPayload = {
        context: "wohnung",
        field: fieldName,
        value: this[fieldName],
      };

      const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
      return validation_result;
    },
    setBpData() {
      const bauprojekt = this.bauprojekte.find((bp) => bp.id == this.$route.params.bauprojekt_id);
      this.bauprojekt_data = bauprojekt;
    },
    setWohnungData() {
      const wohnung = this.wohnungen.find((wohnung) => wohnung.id == this.$route.params.wohnung_id);
      this.wohnung_data = wohnung;
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    debug() {
      console.log(this.selected_haus);
    },
  },
};
</script>

<style scoped>
.priceCon {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.priceCon div:first-of-type {
  width: 45%;
}

.form-group {
  position: relative;
}

#add_preis,
#show_preis {
  margin-bottom: 20px;
  border-bottom: 2px solid #004f7d;
}

#add_preis div {
  padding-right: 5px;
}

.flex-col {
  display: flex;
  flex-flow: column;
  margin-bottom: 10px;
}

.flex-col input {
  width: 100%;
}

.kaufpreis_inputs button {
  height: 38px;
  align-self: flex-end;
  margin-bottom: 10px;
}

.kaufpreis_inputs,
.kaufpreis_labels {
  display: flex;
  justify-content: flex-start;
}

.kaufpreis_labels {
  align-items: flex-start;
}

.input-buttons-inside {
  position: relative;
}

.input-buttons-right {
  display: flex;
  align-items: center;
}

.checkmark {
  color: green;
}

.failmark {
  color: red;
}

.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark,
.failmark {
  position: absolute;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark.select,
.loader.select {
  right: 30px;
  z-index: 1000;
}
</style>
